// src/api_scripts/getteamList.js
import { fetchAllPages } from "../paginationUtils";

const getteamList = async (teamListName, orgId, accessToken, setProgress) => {
  const relativeUri = `organization/${orgId}/v2/team`;

  try {
    const dataArray = await fetchAllPages(relativeUri, accessToken, setProgress, "Teams");
    console.log("Get Teams API Response Data (all pages):", dataArray.length, "items");
    return dataArray;

  } catch (error) {
    console.error(`Error fetching Teams:`, error);
    throw error;
  }
};

export default getteamList;